<template>
  <div class="flow-arrow">
    <svg
      class="flow-arrow__icon"
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M2.5 2.5 9.5 8l-7 5.5"
        stroke="rgba(42,138,234,0.55)"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>

<style lang="scss" scoped>
.flow-arrow {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  z-index: 2;
}

@media (max-width: 767px) {
  .flow-arrow {
    width: 100%;
    justify-content: center;
    padding: 12px 0;
  }

  .flow-arrow__icon {
    transform: rotate(90deg);
  }
}
</style>
